import {Entity} from "../commons/entity";
import {FX} from "./fx";
/**
 * Created by Lauta on 21/2/2017.
 */

export class Role implements Entity{
    public id: number = null;
    public name: string = "";
    public fxs: Array<FX> = [];

    constructor(value: Object = {}) {
        Object.assign(this, value);
        if (this.fxs)
            this.fxs = this.fxs.map(fx => new FX(fx));
    }

    public hasFX(fx: FX): boolean {
        return this.fxs.some(f => f.equals(fx));
    }

    public addFX(fx: FX) {
        if(!this.hasFX(fx)) this.fxs.push(fx);
    }

    public removeFX(fx: FX) {
        this.fxs = this.fxs.filter(f => !f.equals(fx));
    }
}



// WEBPACK FOOTER //
// ./src/app/core/domain/role.ts